import cn from 'classnames';
import Link from 'next/link';
import i18n from '@/settings/i18n';
import { isUnlocked } from '../../product/helpers';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { DefaultOptionProps } from '../types';

const t = i18n.init('product');

const DefaultOption = ({
  isSelected,
  offer,
  value,
  className,
  variantSlug,
}: DefaultOptionProps) => {
  const { productId } = useProductPageContext();

  const variantValue = value.displayValue ?? value.value;

  return (
    <div className={cn(className, 'relative')}>
      <Link
        href={`/collections/${encodeURIComponent(
          productId,
        )}?skuId=${encodeURIComponent(offer.skuId)}`}
        shallow
        scroll={false}
        id={`e2e-pdp-${variantSlug}-${variantValue}`}
        className={cn(
          'flex h-10 flex-col items-center justify-center rounded border px-2 leading-none focus:outline-none',
          {
            'border-gray-700 font-bold': isSelected,
            'border-gray-700/25 hover:border-gray-700': !isSelected,
            'h-11': variantSlug === 'carrier',
          },
        )}
      >
        <span>{variantValue}</span>
        {variantSlug === 'carrier' && isUnlocked(variantValue) && (
          <span className="mt-1 text-xxs font-normal text-gray-700/60">
            {t`Works with all carriers`}
          </span>
        )}
      </Link>
    </div>
  );
};

export default DefaultOption;
